/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit-element';

/**
 * Tooltip CSS
 */
export const styles = css`

:host {
    --max-width: 20rem;
    --hide-delay: 0ms;
    --show-delay: 150ms;

    display: contents;
  }

  .tooltip {
    --arrow-size: 6px;
    --arrow-color: hsl(240 3.7% 15.9%);
  }

  .tooltip::part(popup) {
    pointer-events: none;
    z-index: 1000;
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .tooltip__body {
    display: block;
    width: max-content;
    max-width: undefined;
    border-radius: 0.25rem;
    background-color: hsl(240 3.7% 15.9%);
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.4;
    color: hsl(0, 0%, 100%);
    padding: 0.25rem 0.5rem;
    pointer-events: none;
  }
`;

export default [styles];
